import { Close, Info } from "@mui/icons-material";
import {
  DialogContent,
  Dialog,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { render } from "storyblok-rich-text-react-renderer";
import "./styles.css";

interface Props {
  tooltip: any;
}

export default function Tooltip(props: Props) {
  const { tooltip } = props;
  const [isOpen, setOpen] = useState<boolean>(false);

  return (
    <>
      <IconButton
        size="small"
        onClick={() => setOpen(true)}
        aria-label="Informação sobre o indicador"
      >
        <Info fontSize="small" className="text-primary" />
      </IconButton>
      {isOpen && (
        <Dialog
          className="w-full"
          open
          fullScreen={false}
          onClose={() => setOpen(false)}
        >
          <AppBar className="!bg-primary" sx={{ position: "relative" }}>
            <Toolbar className="flex">
              <IconButton
                className="!absolute"
                color="inherit"
                onClick={() => setOpen(false)}
                aria-label="Fechar"
              >
                <Close />
              </IconButton>
              <Typography className="!mx-auto" variant="h6" component="div">
                Informação sobre o indicador
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent sx={{ overscrollBehavior: "contain" }}>
            {typeof tooltip === "string" ? (
              <p className="leading-relaxed text-gray">{tooltip}</p>
            ) : (
              <div
                className="webview content"
                dangerouslySetInnerHTML={{
                  __html: renderToStaticMarkup(render(tooltip)),
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
